import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-24">
        <Link
          to="/"
          className="text-amber-700 hover:text-amber-800 font-medium mb-8 inline-block"
        >
          ← Back to Home
        </Link>
        
        <h1 className="text-5xl font-bold text-slate-900 mb-8">Privacy Policy</h1>
        
        <div className="prose prose-slate max-w-none space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">1. Introduction</h2>
            <p>
              Tiller Kingsley Bale Associates ("we," "us," or "our") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information when 
              you visit our website tillerkingsleybaleassociates.com and engage our professional legal services.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">2. Information We Collect</h2>
            <p className="mb-4">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Name and contact information (email address, phone number)</li>
              <li>Information about your legal inquiry or matter</li>
              <li>Communication preferences</li>
              <li>Any other information you choose to provide</li>
            </ul>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">3. How We Use Your Information</h2>
            <p className="mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide legal services and respond to your inquiries</li>
              <li>Communicate with you about our services</li>
              <li>Send you legal updates and information you may find useful</li>
              <li>Comply with legal obligations and professional responsibilities</li>
              <li>Improve our website and services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">4. Attorney-Client Privilege</h2>
            <p>
              Communication through our website contact form initiates the process for establishing an 
              attorney-client relationship. To formally engage our legal services, we will schedule a consultation 
              to discuss your legal needs and provide appropriate representation agreements. Confidential or 
              time-sensitive information should be discussed during a scheduled consultation or through secure channels 
              we will provide once representation is established.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">5. Information Sharing</h2>
            <p>
              We do not sell, trade, or rent your personal information to third parties. We may share your 
              information only in the following circumstances:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>With your consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights and the rights of others</li>
              <li>With service providers who assist us in operating our website (subject to confidentiality obligations)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">6. Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect your personal 
              information. However, no method of transmission over the internet or electronic storage is 100% 
              secure. While we strive to protect your information, we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">7. Your Rights</h2>
            <p className="mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information (subject to legal retention requirements)</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. The updated version will be indicated by 
              an updated "Last Updated" date. We encourage you to review this Privacy Policy periodically.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">9. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact us at:
            </p>
            <p className="mt-4">
              <strong>Tiller Kingsley Bale Associates</strong><br />
              Email: info@tillerkingsleybaleassociates.com
            </p>
          </section>

          <section className="border-t border-slate-200 pt-8 mt-12">
            <p className="text-sm text-slate-500">
              Last Updated: January 2026
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
